import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.ACCOUNTS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_PATH,
	name: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
    props: true,
	component: () => import('@/views/accounts/BalancesAndMovements')
}, {
	path: routeList.ACCOUNTS_PATRIMONY_PATH,
	name: routeList.ACCOUNTS_PATRIMONY_NAME,
	component: () => import('@/views/accounts/Patrimony')
}, {
	path: routeList.ACCOUNTS_CASHFLOW_PATH,
	name: routeList.ACCOUNTS_CASHFLOW_NAME,
	component: () => import('@/views/UnderDevelopment')
}, {
	path: routeList.ACCOUNTS_EXTRACTS_PATH,
	name: routeList.ACCOUNTS_EXTRACTS_NAME,
	component: () => import('@/views/accounts/Extracts')
}, {
	path: routeList.ACCOUNTS_INVOICES_PATH,
	name: routeList.ACCOUNTS_INVOICES_NAME,
	component: () => import('@/views/accounts/Invoices')
}, {
	path: routeList.ACCOUNTS_DETAILS_PATH,
	name: routeList.ACCOUNTS_DETAILS_NAME,
	props: true,
	component: () => import('@/views/accounts/Details')
},
/* ***********************************************
*                       WALLET                   *
*********************************************** */
{
	path: routeList.ACCOUNTS_WALLET_PATH,
	name: routeList.ACCOUNTS_WALLET_NAME,
	props: true,
	component: () => import('@/views/ThirdLevelMenu')
}, {
	path: routeList.ACCOUNTS_WALLET_CREATE_PATH,
	name: routeList.ACCOUNTS_WALLET_CREATE_NAME,
	component: () => import('@/views/UnderDevelopment')
}, {
	path: routeList.ACCOUNTS_WALLET_REGIST_PATH,
	name: routeList.ACCOUNTS_WALLET_REGIST_NAME,
	component: () => import('@/views/UnderDevelopment')
}, {
	path: routeList.ACCOUNTS_WALLET_LIMITS_PATH,
	name: routeList.ACCOUNTS_WALLET_LIMITS_NAME,
	component: () => import('@/views/UnderDevelopment')
},
/* ******************* ************************ */
{
	path: routeList.ACCOUNTS_VISIBLE_PATH,
	name: routeList.ACCOUNTS_VISIBLE_NAME,
	component: () => import('@/views/accounts/Visible')
}]
